/** Codice ISTAT Italia (dizionario stati Alloggiati / CIE). */
export const CODICE_STATO_ITALIA = "100000100";

export function isCodiceIstatStato(codice) {
  return /^\d{9}$/.test(String(codice || "").trim());
}

export function isEtichettaItalia(val) {
  const s = String(val || "").trim().toUpperCase();
  return s === "ITALIA" || s === "ITALIANA";
}

/**
 * Codice ISTAT a 9 cifre, oppure "" se non determinabile.
 * Accetta etichette ITALIA/ITALIANA anche se salvate per errore nel campo codice
 * (il portale rifiuta il testo «ITALIANA» come cittadinanza).
 * Codice e etichetta vuoti → Italia (default legacy).
 */
export function normalizzaCodiceStatoAlloggiati(codice, label) {
  const c = String(codice || "").trim();
  if (isCodiceIstatStato(c)) return c;
  if (isEtichettaItalia(c) || isEtichettaItalia(label)) return CODICE_STATO_ITALIA;
  if (!c && !String(label || "").trim()) return CODICE_STATO_ITALIA;
  return "";
}

/** Etichetta da mostrare in UI (ITALIANA → ITALIA). */
export function etichettaStatoAlloggiati(codice, label) {
  const lab = String(label || "").trim();
  if (lab && !isCodiceIstatStato(lab)) {
    return lab.toUpperCase() === "ITALIANA" ? "ITALIA" : lab;
  }
  const c = String(codice || "").trim();
  if (isEtichettaItalia(c) || c === CODICE_STATO_ITALIA || !c) return "ITALIA";
  return lab || "";
}

/** True se stato di nascita non è Italia (codice ISTAT o etichetta). */
export function isNatoAllEstero(statoCodice, statoLabel) {
  const c = String(statoCodice || "").trim();
  if (isCodiceIstatStato(c)) return c !== CODICE_STATO_ITALIA;
  if (isEtichettaItalia(c) || isEtichettaItalia(statoLabel)) return false;
  const lab = String(statoLabel || "").trim();
  if (!lab && !c) return false;
  return true;
}
